import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import {
  BonificoBusinessInformation,
  BonificoOrderDTO,
  VatExemption,
} from "./BonificoOrderDTO.ts";

export function useUpdateBonificoOrderBilling() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const updateBilling = async (
    orderId: string,
    billing: {
      businessInformation: BonificoBusinessInformation;
      taxCode?: string;
      vatExemption?: VatExemption | null;
    },
  ): Promise<BonificoOrderDTO> => {
    setLoading(true);
    try {
      const { data } = await createAxiosInstance().put<BonificoOrderDTO>(
        `/bonifico-orders/${orderId}/billing`,
        billing,
      );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return { updateBilling, loading };
}
